import { render, staticRenderFns } from "./Dentistas.vue?vue&type=template&id=0fd12c1a&"
import script from "./Dentistas.vue?vue&type=script&lang=js&"
export * from "./Dentistas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports